export async function findAddressByCep(cep) {
  if (!/^\d{8}$/.test(cep)) throw new Error('Informe um CEP com 8 dígitos.');
  const failure =
    'Não foi possível consultar o CEP. Preencha o endereço manualmente ou tente novamente.';
  let data;
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
      headers: { Accept: 'application/json' },
      credentials: 'omit',
    });
    if (!response.ok) throw new Error(failure);
    data = await response.json();
  } catch (error) {
    throw new Error(failure);
  }
  if (data?.erro === true || data?.erro === 'true') {
    throw new Error('CEP não encontrado. Confira o número ou preencha o endereço manualmente.');
  }
  if (
    typeof data?.localidade !== 'string' ||
    !data.localidade ||
    typeof data?.uf !== 'string' ||
    !data.uf
  ) {
    throw new Error(failure);
  }
  return {
    logradouro: typeof data.logradouro === 'string' ? data.logradouro : '',
    complemento: typeof data.complemento === 'string' ? data.complemento : '',
    bairro: typeof data.bairro === 'string' ? data.bairro : '',
    cidade: data.localidade,
    estado: data.uf,
  };
}
